// What to show when Generate Summary is refused (QA #15): the API's own instruction first
// (e.g. "Upload a measurement report or add measurements..."), then its message, then a generic line.
export function summaryErrorText(e: unknown): string {
  const data = (e as { data?: { message?: string; detail?: string } } | undefined)?.data;
  return data?.detail || data?.message || 'Could not generate a summary — try again.';
}
